module.exports = __webpack_public_path__ + "img/apexlegends-logo.aaf65fae.svg";